export default "__VITE_ASSET__DN1O11mB__"